Object.defineProperty(exports,"__esModule",{value:true});exports.brushContainerMixin=undefined;var _isEqual2=require("lodash/isEqual");var _isEqual3=_interopRequireDefault(_isEqual2);var _defaults2=require("lodash/defaults");var _defaults3=_interopRequireDefault(_defaults2);var _assign2=require("lodash/assign");var _assign3=_interopRequireDefault(_assign2);var _this2=this;var _extends=Object.assign||function(target){for(var i=1;i<arguments.length;i++){var source=arguments[i];for(var key in source){if(Object.prototype.hasOwnProperty.call(source,key)){target[key]=source[key];}}}return target;};var _createClass=function(){function defineProperties(target,props){for(var i=0;i<props.length;i++){var descriptor=props[i];descriptor.enumerable=descriptor.enumerable||false;descriptor.configurable=true;if("value"in descriptor)descriptor.writable=true;Object.defineProperty(target,descriptor.key,descriptor);}}return function(Constructor,protoProps,staticProps){if(protoProps)defineProperties(Constructor.prototype,protoProps);if(staticProps)defineProperties(Constructor,staticProps);return Constructor;};}();var _react=require("react");var _react2=_interopRequireDefault(_react);
var _victoryCore=require("victory-core");
var _brushHelpers=require("./brush-helpers");var _brushHelpers2=_interopRequireDefault(_brushHelpers);function _interopRequireDefault(obj){return obj&&obj.__esModule?obj:{default:obj};}function _toConsumableArray(arr){if(Array.isArray(arr)){for(var i=0,arr2=Array(arr.length);i<arr.length;i++){arr2[i]=arr[i];}return arr2;}else{return Array.from(arr);}}function _classCallCheck(instance,Constructor){if(!(instance instanceof Constructor)){throw new TypeError("Cannot call a class as a function");}}function _possibleConstructorReturn(self,call){if(!self){throw new ReferenceError("this hasn't been initialised - super() hasn't been called");}return call&&(typeof call==="object"||typeof call==="function")?call:self;}function _inherits(subClass,superClass){if(typeof superClass!=="function"&&superClass!==null){throw new TypeError("Super expression must either be null or a function, not "+typeof superClass);}subClass.prototype=Object.create(superClass&&superClass.prototype,{constructor:{value:subClass,enumerable:false,writable:true,configurable:true}});if(superClass)Object.setPrototypeOf?Object.setPrototypeOf(subClass,superClass):subClass.__proto__=superClass;}


var brushContainerMixin=exports.brushContainerMixin=function brushContainerMixin(base){var _class,_temp;return _temp=_class=function(_base){_inherits(VictoryBrushContainer,_base);function VictoryBrushContainer(){_classCallCheck(this,VictoryBrushContainer);return _possibleConstructorReturn(this,(VictoryBrushContainer.__proto__||Object.getPrototypeOf(VictoryBrushContainer)).apply(this,arguments));}_createClass(VictoryBrushContainer,[{key:"getSelectBox",value:function getSelectBox(






















































props,coordinates){var
x=coordinates.x,y=coordinates.y;var
selectionStyle=props.selectionStyle,selectionComponent=props.selectionComponent;
var selectionComponentStyle=selectionComponent.props&&selectionComponent.props.style;
return x[0]!==x[1]&&y[0]!==y[1]?
_react2.default.cloneElement(selectionComponent,{
width:Math.abs(x[1]-x[0])||1,
height:Math.abs(y[1]-y[0])||1,
x:Math.min(x[0],x[1]),
y:Math.min(y[0],y[1]),
cursor:"move",
style:(0,_defaults3.default)({},selectionComponentStyle,selectionStyle)}):
null;
}},{key:"getHandles",value:function getHandles(

props,coordinates){var
dimension=props.dimension,handleWidth=props.handleWidth,handleStyle=props.handleStyle,handleComponent=props.handleComponent;var
x=coordinates.x,y=coordinates.y;
var width=Math.abs(x[1]-x[0])||1;
var height=Math.abs(y[1]-y[0])||1;
var handleComponentStyle=handleComponent.props&&handleComponent.props.style||{};
var style=(0,_defaults3.default)({},handleComponentStyle,handleStyle);
var yProps={style:style,width:width,height:handleWidth,cursor:"ns-resize"};
var xProps={style:style,width:handleWidth,height:height,cursor:"ew-resize"};
var handleProps={
top:dimension!=="x"&&(0,_assign3.default)({x:x[0],y:y[1]-handleWidth/2},yProps),
bottom:dimension!=="x"&&(0,_assign3.default)({x:x[0],y:y[0]-handleWidth/2},yProps),
left:dimension!=="y"&&(0,_assign3.default)({y:y[1],x:x[0]-handleWidth/2},xProps),
right:dimension!=="y"&&(0,_assign3.default)({y:y[1],x:x[1]-handleWidth/2},xProps)};

var handles=["top","bottom","left","right"].reduce(function(memo,curr){
memo=handleProps[curr]?
memo.concat(_react2.default.cloneElement(
handleComponent,
(0,_assign3.default)({key:"handle-"+curr},handleProps[curr]))):
memo;
return memo;
},[]);
return handles.length?handles:null;
}},{key:"getRect",value:function getRect(

props){var
currentDomain=props.currentDomain,cachedSelectedDomain=props.cachedSelectedDomain,scale=props.scale;
var selectedDomain=(0,_defaults3.default)({},props.selectedDomain,props.domain);
var domain=(0,_isEqual3.default)(selectedDomain,cachedSelectedDomain)?
(0,_defaults3.default)({},currentDomain,selectedDomain):selectedDomain;
var coordinates=_victoryCore.Selection.getDomainCoordinates(scale,domain);
var selectBox=this.getSelectBox(props,coordinates);
return selectBox?

_react2.default.createElement("g",null,
selectBox,
this.getHandles(props,coordinates)):

null;
}},{key:"getChildren",value:function getChildren(


props){
var children=_react2.default.Children.toArray(props.children);
return[].concat(_toConsumableArray(children),[this.getRect(props)]).map(function(component,i){
return component?_react2.default.cloneElement(component,{key:i}):null;
});
}}]);return VictoryBrushContainer;}(base),_class.displayName="VictoryBrushContainer",_class.propTypes=_extends({},_victoryCore.VictoryContainer.propTypes,{selectionStyle:_react2.default.PropTypes.object,handleStyle:_react2.default.PropTypes.object,dimension:_react2.default.PropTypes.oneOf(["x","y"]),selectedDomain:_react2.default.PropTypes.shape({x:_react2.default.PropTypes.array,y:_react2.default.PropTypes.array}),onDomainChange:_react2.default.PropTypes.func,handleWidth:_react2.default.PropTypes.number,selectionComponent:_react2.default.PropTypes.element,handleComponent:_react2.default.PropTypes.element}),_class.defaultProps=_extends({},_victoryCore.VictoryContainer.defaultProps,{selectionStyle:{stroke:"transparent",fill:"black",fillOpacity:0.1},handleStyle:{stroke:"transparent",fill:"transparent"},handleWidth:8,selectionComponent:_react2.default.createElement("rect",null),handleComponent:_react2.default.createElement("rect",null)}),_class.defaultEvents=[{target:"parent",eventHandlers:{onMouseDown:function onMouseDown(evt,targetProps){return _brushHelpers2.default.onMouseDown(evt,targetProps);},onMouseMove:function onMouseMove(evt,targetProps){var mutations=_brushHelpers2.default.onMouseMove(evt,targetProps);if(mutations.id!==_this2.mouseMoveMutationId){_this2.mouseMoveMutationId=mutations.id;return mutations.mutations;}},onMouseUp:function onMouseUp(evt,targetProps){return _brushHelpers2.default.onMouseUp(evt,targetProps);},onMouseLeave:function onMouseLeave(evt,targetProps){return _brushHelpers2.default.onMouseLeave(evt,targetProps);}}}],_temp;};exports.default=


brushContainerMixin(_victoryCore.VictoryContainer);


//////////////////
// WEBPACK FOOTER
// ./~/victory-chart/lib/components/containers/victory-brush-container.js
// module id = 676
// module chunks = 0